import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// payment_allocations — จัดสรรเงินชำระเข้า invoice
// ============================================================================
export const paymentAllocations = sqliteTable("accounting_payment_allocations", {
  id: text("id").primaryKey(), // ULID
  // Polymorphic payment header id: accounting_payments.id or accounting_receipts.id.
  paymentId: text("payment_id").notNull(),
  // Polymorphic FK to one of the canonical owner invoice tables.
  invoiceId: text("invoice_id").notNull(),
  allocatedAmount: real("allocated_amount").notNull(),
  allocationDate: text("allocation_date"),
  allocationType: text("allocation_type", {
    enum: ["invoice", "reallocation"],
  })
    .notNull()
    .default("invoice"),
  status: text("status", {
    enum: ["active", "reversed"],
  })
    .notNull()
    .default("active"),
  glSourceId: text("gl_source_id"),
  reversalOf: text("reversal_of"),
  reversedAt: text("reversed_at"),
  reversedBy: text("reversed_by"),
  reversalReason: text("reversal_reason"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at"),
  updatedBy: text("updated_by"),
}, (table) => ({
  paymentStatusIdx: index("pay_alloc_payment_status_idx").on(table.paymentId, table.status),
  invoiceStatusIdx: index("pay_alloc_invoice_status_idx").on(table.invoiceId, table.status),
}));

// Type exports
export type PaymentAllocation = typeof paymentAllocations.$inferSelect;
export type NewPaymentAllocation = typeof paymentAllocations.$inferInsert;
